<template>
  <div>
    <div class="app-toolbar1">
      <el-button size="small" @click="toAdd" type="primary">添加</el-button>
      <el-button size="small" @click="load(1)">查询</el-button>
    </div>
    <el-table :data="apiDataSources" :stripe="true" size="mini" v-loading="loading">
      <el-table-column prop="apiDataSourceId" label="ID" width="80"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="136"></el-table-column>
      <el-table-column prop="projectName" label="所属项目"></el-table-column>
      <el-table-column prop="systemName" label="所属后端系统"></el-table-column>
      <el-table-column prop="name" label="数据源名称" width="160px"></el-table-column>
      <el-table-column prop="acType" label="访问控制类型" width="94px">
        <template slot-scope="scope">
          <span v-if="scope.row.acType === acType.key" v-for="acType in acTypes" :key="acType.key">{{acType.label}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="数据类型" :formatter="typeFormatter" width="68px"></el-table-column>
      <el-table-column prop="url" label="地址" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="invoker" label="调用器" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="desc" label="描述" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button @click="toUpdate(scope.row)" type="primary" size="small">修改</el-button>
          <el-button @click="toDelete(scope.row)" type="danger" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-show="query.total > 0" :page-size="query.limit" :pager-count="11" layout="total, prev, pager, next" :total="query.total" :background="true" @current-change="load" class="app-pagination"></el-pagination>

    <el-dialog :title="formTitle" :visible.sync="showForm" @close="resetForm">
      <el-form :model="form" :rules="formRule" ref="form" :status-icon="true" label-position="top">
        <el-form-item label="所属后端系统" prop="systemId">
          <el-select placeholder="请选择所属后端系统" v-model="form.systemId" style="width:100%">
            <el-option v-for="system in systems" :key="system.systemId" :value="system.systemId" :label="system.name">
              {{ system.name }}<span class="ads-option-desc">{{ system.projectName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入API数据源的名称"></el-input>
        </el-form-item>
        <el-form-item label="访问控制类型" prop="acType">
          <el-radio-group v-model="form.acType">
            <el-radio-button :label="acType.key" v-for="acType in acTypes" :key="acType.key">{{acType.label}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="数据类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio-button label="OBJECT">单条数据</el-radio-button>
            <el-radio-button label="LIST">列表</el-radio-button>
            <el-radio-button label="PAGE">分页</el-radio-button>
            <el-radio-button label="FIELD">单个字段</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="地址" prop="url">
          <el-input v-model="form.url" placeholder="请输入API数据源的地址"></el-input>
        </el-form-item>
        <el-form-item label="调用器" prop="invoker">
          <el-input v-model="form.invoker" placeholder="请输入调用器的类名"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input v-model="form.desc" placeholder="请输入API数据源的描述信息" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showForm = false">取 消</el-button>
        <el-button type="primary" @click="doSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { calcPage } from '@/util'
import { acTypes } from '@/config'

export default {
  name: 'api-data-source',
  data () {
    return {
      acTypes: acTypes,
      systems: [],
      loading: false,
      apiDataSources: [],
      query: {
        page: 1,
        limit: 10,
        total: 0
      },
      showForm: false,
      formTitle: '添加API数据源',
      form: {
        apiDataSourceId: 0,
        systemId: 0,
        name: '',
        acType: '',
        type: '',
        url: '',
        invoker: '',
        desc: ''
      },
      formRule: {
        systemId: [{ required: true, message: '请选择后端系统', trigger: 'change' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        acType: [{ required: true, message: '请选择访问控制类型', trigger: 'change' }],
        type: [{ required: true, message: '请选择数据类型', trigger: 'change' }],
        url: [{ required: true, message: '请输入地址', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.loadSystem()
    this.load(1)
  },
  methods: {
    loadSystem () {
      this.$http.request({
        method: 'get',
        url: '/api/cgSystems'
      }).then((res) => {
        this.systems = res.data.data || []
      })
    },
    load (page) {
      this.loading = true
      this.$http.request({
        method: 'get',
        url: `/api/cgApiDataSources?page=${page}&limit=${this.query.limit}`
      }).then((res) => {
        let pageData = res.data.data
        this.apiDataSources = pageData.data
        this.query.page = pageData.page
        this.query.total = pageData.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    toAdd () {
      this.formTitle = '添加API数据源'
      this.form = { apiDataSourceId: 0, systemId: null, name: '', acType: '', type: '', url: '', invoker: '', desc: '' }
      this.showForm = true
    },
    toUpdate (row) {
      this.formTitle = '修改API数据源'
      this.form = { apiDataSourceId: row.apiDataSourceId, systemId: row.systemId, name: row.name, acType: row.acType, type: row.type, url: row.url, invoker: row.invoker, desc: row.desc }
      this.showForm = true
    },
    toDelete (row) {
      this.$store.commit('confirm', { title: '提示', msg: '您确认要删除该API数据源吗?', data: row, scope: this, callback: this.doDelete })
    },
    doSave () {
      this.$refs.form.validate((success) => {
        if (success) {
          let apiDataSourceId = this.form.apiDataSourceId
          this.$http.request({
            method: apiDataSourceId === 0 ? 'post' : 'put',
            url: apiDataSourceId === 0 ? '/api/cgApiDataSources' : `/api/cgApiDataSources/${apiDataSourceId}`,
            data: JSON.stringify({
              systemId: this.form.systemId,
              name: this.form.name,
              acType: this.form.acType,
              type: this.form.type,
              url: this.form.url,
              invoker: this.form.invoker,
              desc: this.form.desc
            })
          }).then(() => {
            this.showForm = false
            this.load(this.query.page)
          })
        } else {
          return false
        }
      })
    },
    doDelete (result, data) {
      if (result) {
        this.$http.request({
          method: 'delete',
          url: `/api/cgApiDataSources/${data.apiDataSourceId}`
        }).then(() => {
          this.$message.success('删除成功')
          this.load(calcPage(this.query))
        })
      }
    },
    typeFormatter (row, column, cellValue) {
      let result = cellValue
      if (cellValue === 'OBJECT') {
        result = '单一对象'
      } else if (cellValue === 'LIST') {
        result = '列表'
      } else if (cellValue === 'PAGE') {
        result = '分页'
      } else if (cellValue === 'FIELD') {
        result = '单个字段'
      }
      return result
    },
    resetForm () {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style>
.ads-option-desc{color:#8492a6;font-size:12px;margin-left:20px}
</style>
